// removed by extract-text-webpack-plugin
module.exports = {"bar":"_3jULjZvTymUaGANA8Tj8PS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylists/components/MyPlaylistsSearchBar.scss
// module id = 1357
// module chunks = 1